import React from "react"
import 'styled-components/macro'
import Breadcrumb from "../../projects/breadcrumb"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { can, VIEW_PROJECTS } from "@src/helpers/authorization"
import { updateUsersAccess } from "@api/project_folders"
import TeamAccess from "../../team_access"

const ProjectFolderNav = ({ breadcrumb, updateUsersAccess, ...props }) => {
  const lastFolder = breadcrumb[breadcrumb.length - 1] || {}
  const projectFolderID = lastFolder._id
  
  // Grab parent users from breadcrumb. Don't use the latest one since those are attached users.
  const parentUsers = breadcrumb.length > 1 ? breadcrumb.slice(0, -1).reduce((acc, folder) => {
    return acc.concat(folder.users || [])
  }, []) : []
  return (
    <React.Fragment>
      <div className='flex items-center'>
        <Breadcrumb breadcrumb={breadcrumb}/>
        {breadcrumb.length > 0 &&
          <TeamAccess
            iconOnly
            attachedUsers={lastFolder.users || []}
            parentUsers={parentUsers}
            updateUsersAccess={(userIDs, callback) => updateUsersAccess(projectFolderID, userIDs, callback)}
            {...props}/>}
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  roleUsers: state.user.auth.organization_id
    ? state.settings.organizations.members.items.filter(user => can(user, [VIEW_PROJECTS]))
    : [],
})

const mapDispatchToProps = dispatch => ({
  updateUsersAccess: bindActionCreators(updateUsersAccess, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectFolderNav)
